import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../ConfigFields/SelectField';

const SOURCE_HELPER_TEXT = `Designate location in cloud storage for text to be stored.`;

export function ExportTextToBucketFormFields() {
  return (
    <>
      <ParentBlockSelectField
        fieldName="config.patient.sourceBlockName"
        label="Patient Source"
        required
        helperText={getSourceBlockNameHelperText('patient')}
      />
      <ParentBlockSelectField
        fieldName="config.source"
        label="Data to export"
        required
        helperText={SOURCE_HELPER_TEXT}
      />
      {/*TODO: Link to doc*/}
    </>
  );
}
